import { render, staticRenderFns } from "./RegionView.vue?vue&type=template&id=4e685dea"
import script from "./RegionView.vue?vue&type=script&lang=ts"
export * from "./RegionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports